import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import RebateHeader from "./component/RebateLandingSearchHeader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import ResponsiveAppBar from "../header/components/responsiveHeaderNew";
import ResponsiveFooter from "../footer/components/ResponsiveFooterNew";
import { PreviewIncentiveResult } from "./rebate-result-IMP.tsx/rebate-result-component";

const queryClient = new QueryClient();

const pageBody: HTMLElement = document.getElementById("rebate") as HTMLElement;
let queryParams : string = window.location.search






if (pageBody) {

const pageNumber : HTMLElement  = document.getElementById('page_number') as HTMLElement;
 let recordsFoundData 
  const lastPage : HTMLElement  = document.getElementById('lastpage') as HTMLElement;
  if(!window.location.href.includes("results")){
    const recordsFound : HTMLCollectionOf<Element> = document.getElementsByClassName('records-found') ;
  let countRegex = /\d+/g
  recordsFoundData = recordsFound[0].textContent?.match(countRegex)?.join('')
  }
  
  const form = document.getElementById('results_form') as HTMLFormElement;
  const serialized = new URLSearchParams((new FormData(form)) as any).toString();
  console.log(serialized);

   let filterurl = "?" + serialized

  const root = ReactDOM.createRoot(pageBody);
  const basePath = pageBody.getAttribute("data-basepath")
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        
        <PreviewIncentiveResult queryParams={filterurl} page={pageNumber.getAttribute("value") ?? ""} formData="" recordsFound={recordsFoundData ?? ""} basePath={basePath ?? ""} isMobile={false} />

      </QueryClientProvider>
    </React.StrictMode>
  );
}
